<section class="accounting-firm-intro-wrapper">
  <div class="box">
    <div class="box__left">
      <div class="box__subheading color-blue" [innerHtml]="'NEW_ACCOUNTING_FIRM.INTRO_SECTION.SUB_HEADING' | translate">
      </div>
      <h1 class="box__heading color-gray box__heading {{ translate.currentLang }}"
        >{{ 'NEW_ACCOUNTING_FIRM.INTRO_SECTION.HEADING' | translate }}
      </h1>
      <div
        class="box__heading-detail box__heading--mw desktop"
        [innerHtml]="'NEW_ACCOUNTING_FIRM.INTRO_SECTION.DETAIL' | translate"
      >
      </div>
      <div
        class="box__heading-detail box__heading--mw mobile"
        [innerHtml]="'NEW_ACCOUNTING_FIRM.INTRO_SECTION.DETAIL_MOBILE' | translate"
      >
      </div>
      <div class="box__btn">
        <a
          id="tracking-findaccountingfirm3"
          target="_blank"
          rel="nofollow"
          href="https://form.flowaccount.com/find-an-accountant"
          class="flowbtn app-btn box__btn--layout"
        >
          {{ 'NEW_ACCOUNTING_FIRM.INTRO_SECTION.BECOME_PARTNER_BUTTON' | translate }}
        </a>
      </div>
    </div>
    <div class="box__right">
      <picture>
        <source
          srcset="
            https://flowaccountcdn.com/new_landing/image/accountingfirm/find-accountingfirm/find_accounting_v3.webp
          "
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/accountingfirm/find-accountingfirm/find_accounting_v3.png"
          width="100%"
          height="auto"
          loading="eager"
          alt="{{ getAltText }}"
          title="{{ getAltText }}"
          class="box__image"
        />
      </picture>
    </div>
  </div>
</section>
